// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__KWeaK","profile_image":"Contact_profile_image__Vg9B7","user_name":"Contact_user_name__iBSOz","message":"Contact_message__j+57A"};